import { useFormContext } from 'react-hook-form';
import { LwFormSelect } from 'redesign';
import { useMemo } from 'react';
import { TimeSlotFormContext, WorkerOptions } from './time-slot.types';

export const AvailabilityWorkersSelect = ({
  disabled = false,
  workerOptions = [],
}: {
  disabled?: boolean;
  workerOptions?: WorkerOptions[];
}) => {
  const { control, setValue, resetField } = useFormContext<TimeSlotFormContext>();

  const selectOptions = useMemo(
    () =>
      workerOptions.map((worker) => ({
        value: worker.id,
        label: `${worker.name} (${worker.description})`,
      })),
    [workerOptions]
  );

  return (
    <LwFormSelect
      name="workerSelect"
      control={control}
      disabled={disabled}
      label="Selecteer de gewenste flexwerker"
      defaultLabel="Selecteer een werknemer"
      options={selectOptions}
      onChange={(e: React.ChangeEvent<{ value: unknown }>) => {
        const value = e.target.value as string;
        const selectedWorker = workerOptions.find((w) => w.id === value);
        if (selectedWorker) {
          setValue('workerOptions', [selectedWorker], { shouldValidate: true });
        } else {
          setValue('workerOptions', [], { shouldValidate: true });
        }
        resetField('availability');
      }}
      rules={{ required: 'Voer een flexwerker in' }}
    />
  );
};
